import React from "react";
import { useRollId } from "../../CommonComponents/RollIdContext"; // Import the useRollId hook

const Filterbtn = ({ filters, setFilters }) => {
  const { rollId } = useRollId(); // Get rollId from context

  const handleFilterApply = (name, value) => {
    setFilters({ ...filters, [name]: value });
  };

  return (
    <div className="ms-4 mb-4 d-flex">
      {rollId === "monazam" && (
        <div className="dropdown me-2">
          <button
            className="btn shadow filter-btn btn-sm btn-outline-secondary dropdown-toggle"
            type="button"
            id="hgoDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            HGO
          </button>
          <ul className="dropdown-menu" aria-labelledby="hgoDropdown">
            <li>
              <a className="dropdown-item" href="#">
                HGO Option
              </a>
            </li>
          </ul>
        </div>
      )}

      <div className="dropdown me-2">
        <button
          className="btn marginRight filter-btn btn-sm btn-outline-secondary dropdown-toggle"
          type="button"
          id="dateDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {!!filters.date ? filters.date : "Date"}
        </button>
        <ul className="dropdown-menu" aria-labelledby="dateDropdown">
          <li>
            <input
              type="date"
              value={filters.date}
              onChange={(e) => {
                handleFilterApply("date", e.target.value);
              }}
            />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Filterbtn;
